import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const MAKE_CORE_FIELDS = gql`
  fragment MakeCoreFields on Make {
    id
    code
    label
    primary
    source
    usage
    addedAt
    hiddenAt
    notes
  }
`;

export const MAKE_FIELDS = gql`
  ${MAKE_CORE_FIELDS}
  fragment MakeFields on Make {
    ...MakeCoreFields
  }
`;

export const MAKE = gql`
  ${MAKE_FIELDS}
  query Make($id: ID!) {
    make(id: $id) {
      ...MakeFields
    }
  }
`;

export const MAKES = gql`
  ${MAKE_FIELDS}
  query Makes (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    makes: makesCollection (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...MakeFields
        }
      }
      totalCount
    }
  }
`;

const MAKE_ARGUMENTS = `
  $code: String!
  $label: String!
  $primary: Boolean!
  $source: String
  $notes: String
`;

const MAKE_VARIABLES = `
  code: $code
  label: $label
  primary: $primary
  source: $source
  notes: $notes
`;

export const CREATE_MAKE = gql`
  ${MAKE_CORE_FIELDS}
  mutation CreateMake (
    ${MAKE_ARGUMENTS}
    $replaceId: ID
  ) {
    createMake (
      ${MAKE_VARIABLES}
      replaceId: $replaceId
    ) {
      make {
        ...MakeCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_MAKE = gql`
  ${MAKE_CORE_FIELDS}
  mutation UpdateMake (
    $id: ID!
    ${MAKE_ARGUMENTS}
  ) {
    updateMake (
      id: $id
      ${MAKE_VARIABLES}
    ) {
      make {
        ...MakeCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_MAKE_HIDDEN = gql`
  ${MAKE_CORE_FIELDS}
  mutation UpdateMakeHidden (
    $id: ID!
    $hidden: Boolean!
  ) {
    updateMakeHidden (
      id: $id
      hidden: $hidden
    ) {
      make {
        ...MakeCoreFields
      }
      ${ERRORS}
    }
  }
`;
